import React from "react";
import PropTypes from "prop-types";
import {
    // List as AntList,
    Modal,
    Icon,
    Card,
    Descriptions,
    Tag,
    Empty
} from "antd";
import { PermissionContextManager } from "hocs/permission-context-manager";
import AddAssociateBankAccountForm from "forms/add-associate-bank-account-form";
import { BankAccountRecord } from "records/company-record";
import noop from "lodash/noop";
import { STATE_STATUS } from "constants/state-status";
// import { BANK_ACCOUNT_TYPES } from "constants/enums";
import LoaderSkeleton from "components/loader-skeleton";
import KeyBankAccountSwitcher from "./key-bank-account-switcher";
import { UI_PERMISSIONS } from "constants/index";
import "styles/case-details-summary.css";
// const ListItem = AntList.Item;
// const ListItemMeta = ListItem.Meta;

export class BankAccountAddList extends React.Component {
    state = {
        status: this.props.status,
        editing: false,
        adding: false,
        switching: false
    };
    formRef = React.createRef();
    switcherRef = React.createRef();
    bankAccount = null;
    toggleModal = () => {
        this.setState({
            adding: !this.state.adding
        });
    };

    toggleEditModal = () => {
        this.setState({
            editing: !this.state.editing
        });
    };

    toggleSwitchModal = () => {
        this.setState({
            switching: !this.state.switching
        });
    };

    editBankAccount = accountId => {
        this.bankAccount = this.props.bankAccounts.find(
            _ => _.id === accountId
        );
        this.toggleEditModal();
    };

    saveBankAccount = actionType => {
        this.formRef.current.validateFields((err, values) => {
            if (!err) {
                values.associate =
                    values.associate === "company" ? null : values.associate;
                try {
                    this.props.update(this.props.companyId, [
                        new BankAccountRecord({
                            id: this.bankAccount ? this.bankAccount.id : null,
                            company: this.props.companyId,
                            is_key_account:
                                !this.props.bankAccounts || (this.props.bankAccounts && !this.props.bankAccounts.size)
                                    ? true
                                    : this.bankAccount
                                        ? this.bankAccount.is_key_account
                                        : false,
                            ...values
                        })
                    ], this.props.caseId);
                    this.bankAccount = null;
                    if(actionType === "add") {
                        this.toggleModal();
                        return;
                    }
                    
                    this.toggleEditModal();
                } catch(error) {
                    console.error(error.message);
                }
                
            }
        });
    };

    updateBankAccount = () => {
        const { state } = this.switcherRef.current;
        if (state && state.newKeyAccountId !== state.oldKeyAccountId) {
            const newBankAccount = this.props.bankAccounts
                .find(_ => _.id === state.newKeyAccountId)
                .set("is_key_account", true);
                // .set("associate", newBankAccount.associate === "company" ? null : newBankAccount.associate);
            const oldBankAccount = this.props.bankAccounts.find(
                _ => _.id === state.oldKeyAccountId
            );
            this.toggleSwitchModal();
            if (!oldBankAccount) {
                return this.props.update(this.props.companyId, [
                    newBankAccount
                ], this.props.caseId);
            }
            return this.props.update(this.props.companyId, [
                oldBankAccount.set("is_key_account", false),
                newBankAccount
            ], this.props.caseId);
        } else {
            this.toggleSwitchModal();
        }
    };

    isLoading = () => {
        return (
            [
                STATE_STATUS.UNFETCHED,
                STATE_STATUS.FETCHING,
                STATE_STATUS.UPDATING
            ].includes(this.state.status) || !this.state.status
        );
    };

    componentDidUpdate() {
        if (this.state.status !== this.props.status) {
            this.setState({
                status: this.props.status
            });
        }
    }
    getCardExtra() {
        return this.props.BANK_ACCOUNTS_EDIT &&
        this.props.isUserAllowedToEdit
            ? [
                <a
                    key="key-account"
                    className={"mr-5"}
                    onClick={this.toggleSwitchModal}
                    disabled={this.props.recreditViewOnlyPermission}
                >
                    <Icon type={"swap"} /> Change Key Bank Account
                </a>,
                <a key="add" className={"mr-5"} onClick={this.toggleModal} disabled={this.props.recreditViewOnlyPermission}>
                    <Icon type={"plus"} /> Add Account
                </a>,
                <a key="update-applicability" className={"mr-5"} onClick={this.props.toggleBankAccountModal} disabled={this.props.recreditViewOnlyPermission}>
                    <Icon type={"redo"} /> Select Bank Account Applicable To Case
                </a>
            ]
            : [];
    }
    getEditAction(id) {
        return this.props.BANK_ACCOUNTS_EDIT && this.props.isUserAllowedToEdit && !this.props.recreditViewOnlyPermission ? (
            <a onClick={this.editBankAccount.bind(null, id)}>
                Edit <Icon type={"edit"} />
            </a>
        ) : null;
    }

    is_applicable = (val) => {
        const account = this.props.applicableAccounts && this.props.applicableAccounts.find(_ => _.company_bank_account == val);
        if(account) {
            return account.is_applicable;
        }
        return false;
    }

    render() {
        const { bankAccounts } = this.props;
        return (
            <React.Fragment>
                <Modal
                    visible={this.state.adding}
                    width={800}
                    maskClosable={true}
                    onCancel={this.toggleModal}
                    onOk={this.saveBankAccount.bind(null, "add")}
                    okText={"Submit"}
                    title={"Add Bank Account"}
                    destroyOnClose
                >
                    <AddAssociateBankAccountForm
                        ref={this.formRef}
                        associates={this.props.associates.toList()}
                    />
                </Modal>
                <Modal
                    visible={this.state.editing}
                    width={800}
                    maskClosable={true}
                    onCancel={this.toggleEditModal}
                    onOk={this.saveBankAccount.bind(null, "edit")}
                    okText={"Submit"}
                    title={"Edit Bank Account"}
                    destroyOnClose
                >
                    <AddAssociateBankAccountForm
                        ref={this.formRef}
                        values={this.bankAccount}
                        associates={this.props.associates.toList()}
                    />
                </Modal>
                <Modal
                    visible={this.state.switching}
                    width={600}
                    maskClosable={true}
                    onCancel={this.toggleSwitchModal}
                    onOk={this.updateBankAccount}
                    okText={"Switch"}
                    title={"Change Key Bank Account"}
                    destroyOnClose
                >
                    <KeyBankAccountSwitcher
                        bankAccounts={bankAccounts}
                        ref={this.switcherRef}
                    />
                </Modal>
                <Card
                    className={"padless-card bank-account-list-card"}
                    title={"Bank Accounts"}
                    extra={this.getCardExtra()}
                >
                    <LoaderSkeleton loading={this.isLoading()}>
                        {!bankAccounts || bankAccounts.size === 0 ? (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        ) : null}
                        {bankAccounts && bankAccounts
                            .map(_ => (
                                <Card.Grid
                                    key={_.id}
                                    style={{
                                        width: "100%"
                                    }}
                                >
                                    <div className={"d-flex flex-column"}>
                                        <div
                                            style={{
                                                textAlign: "right"
                                            }}
                                            className={"mb-5"}
                                        >
                                            {this.is_applicable(_.id) ? (
                                                <Tag
                                                    color={"#87d068"}
                                                    className={"mr-5"}
                                                >
                                                    Applicable
                                                </Tag>
                                            ) : null}
                                            {_.is_key_account ? (
                                                <Tag
                                                    color={"#87d068"}
                                                    className={"mr-5"}
                                                >
                                                    Key Account
                                                </Tag>
                                            ) : null}
                                            {this.getEditAction(_.id)}
                                        </div>
                                        <Descriptions bordered column={1}>
                                            {_.description_list
                                                .map((value, label) => (
                                                    <Descriptions.Item
                                                        key={label}
                                                        label={label}
                                                    >
                                                        {value &&
                                                            value._isAMomentObject
                                                            ? value.format(
                                                                "DD-MM-YYYY"
                                                            )
                                                            : value}
                                                    </Descriptions.Item>
                                                ))
                                                .toList()}
                                        </Descriptions>
                                    </div>
                                </Card.Grid>
                            ))
                            .toList()}
                    </LoaderSkeleton>
                </Card>
            </React.Fragment>
        );
    }
}

BankAccountAddList.defaultProps = {
    bankAccounts: [],
    associates: [],
    applicableAccounts: [],
    update: noop
};

BankAccountAddList.propTypes = {
    companyId: PropTypes.number,
    bankAccounts: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    associates: PropTypes.object,
    update: PropTypes.func,
    status: PropTypes.string,
    BANK_ACCOUNTS_EDIT: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    caseId: PropTypes.number,
    applicableAccounts: PropTypes.array,
    toggleBankAccountModal: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default PermissionContextManager({
    permission: UI_PERMISSIONS.BANK_ACCOUNTS_VIEW,
    propsPermissions: {
        BANK_ACCOUNTS_EDIT: UI_PERMISSIONS.BANK_ACCOUNTS_EDIT
    }
})(BankAccountAddList);
